import request from '@/utils/request'
import { fetchMediaBlob, normalizeMediaId } from '@/utils/media-delivery'

export function fetchLegacyHome() {
  return request({
    url: '/platform/legacy/home',
    method: 'get'
  })
}

export function updateLegacyProfile(data) {
  const form = new FormData()
  Object.keys(data || {}).forEach(key => form.append(key, data[key] == null ? '' : data[key]))
  return request({ successMessage: '保存成功',
    url: '/platform/legacy/profile',
    method: 'post',
    data: form
  })
}

export function uploadLegacySignature(file) {
  const form = new FormData()
  form.append('file', file)
  return request({ successMessage: '上传成功',
    url: '/platform/legacy/signature',
    method: 'post',
    data: form
  })
}

export function signatureUrl(signature) {
  return `${process.env.VUE_APP_BASE_API}/platform/legacy/signature?signature=${encodeURIComponent(signature || 0)}`
}

export function fetchLegacySignature(signature, staged = false) {
  if (!staged && normalizeMediaId(signature)) return fetchMediaBlob(signature)
  return request({ url: '/platform/legacy/signature', method: 'get', params: { signature }, responseType: 'blob' })
}

export function importLegacyLicense(file) {
  const form = new FormData()
  form.append('licenseKey', file)
  return request({ successMessage: '导入成功',
    url: '/platform/legacy/license/import',
    method: 'post',
    data: form
  })
}

export function systemKeyUrl() {
  return `${process.env.VUE_APP_BASE_API}/platform/legacy/license/system-key`
}
